/**
 * Tiroir de menu — l'ouverture, et rien d'autre.
 *
 * Le <dialog> natif apporte déjà la fermeture par Échap, le piège à focus,
 * le voile (::backdrop) et — via `scroll-lock` et la règle
 * `html:has(dialog[scroll-lock][open])` de critical.css — le verrou de
 * défilement. Tout ce qui reste à écrire, c'est showModal().
 *
 * Délégation sur le document plutôt qu'un écouteur par bouton : l'éditeur de
 * thème remplace le HTML de la section à chaque modification de réglage, ce
 * qui décrocherait des écouteurs posés sur les éléments.
 */
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-menu-open]');
  if (opener) {
    const section = opener.closest('.shopify-section');
    const tiroir = section?.querySelector('dialog.hdr-menu');
    if (!tiroir) return;
    copierLesGammes(section, tiroir);
    copierLesLiensDAnnonce(section, tiroir);
    tiroir.showModal();
    return;
  }

  const closer = event.target.closest('[data-menu-close]');
  if (closer) closer.closest('dialog')?.close();
});

/**
 * Sous « Matelas », le tiroir déplie les gammes du méga-menu — produits et
 * prix compris (retour du 2026-08-23). Ces gammes sont des blocs de thème,
 * qui ne se rendent qu'une fois par section : elles vivent dans le méga-menu
 * du bureau. On les clone ici à la première ouverture, plutôt que de tenir
 * un second inventaire dans le Liquid.
 *
 * Le pied du méga-menu (« Pas sûr de votre choix ? » et ses boutons) reste
 * dehors : le tiroir a déjà son propre pied. Les attributs d'éditeur partent
 * avec, sinon l'éditeur de thème ne saurait plus quel bloc surligner.
 */
function copierLesGammes(section, tiroir) {
  const cible = tiroir.querySelector('[data-menu-gammes]');
  if (!cible || cible.childElementCount) return;

  const gammes = section.querySelector('.nv-mega .gm-cols');
  if (!gammes) return;

  const copie = gammes.cloneNode(true);
  for (const el of [copie, ...copie.querySelectorAll('*')]) {
    for (const { name } of [...el.attributes]) {
      if (name.startsWith('data-shopify')) el.removeAttribute(name);
    }
    el.removeAttribute('id');
  }
  cible.append(copie);
}

/**
 * Clic sur le voile : un <dialog> occupe toute la fenêtre du point de vue de
 * l'événement, même si le tiroir n'en peint qu'une bande. On compare donc la
 * position du clic à la boîte réelle du tiroir.
 */
document.addEventListener('click', (event) => {
  const dialog = event.target.closest('dialog.hdr-menu');
  if (!dialog || event.target !== dialog) return;

  const box = dialog.getBoundingClientRect();
  const inside =
    event.clientX >= box.left &&
    event.clientX <= box.right &&
    event.clientY >= box.top &&
    event.clientY <= box.bottom;

  if (!inside) dialog.close();
});

/**
 * Les liens de la barre d'annonce — Notre Histoire, Test sommeil, Espace
 * Pros, Nous contacter — disparaissent sous 760px avec la barre. On les
 * recopie dans le tiroir à la première ouverture, depuis la barre
 * elle-même : c'est le client qui la règle, et il n'a pas à tenir une
 * seconde liste pour le mobile. Chaque lien reçoit la flèche des autres
 * entrées ; celui qui ouvre le quiz garde son attribut, et le tiroir se
 * ferme d'abord — deux dialogues ouverts l'un sur l'autre se disputeraient
 * le focus.
 */
function copierLesLiensDAnnonce(section, tiroir) {
  const ancre = tiroir.querySelector('[data-menu-annonce]');
  if (!ancre || ancre.dataset.fait) return;
  ancre.dataset.fait = '1';

  /* La barre d'annonce est une section sœur : chaque section porte la classe
     du groupe pour elle-même, il n'y a pas d'ancêtre commun à interroger. */
  const liens = document.querySelectorAll('.anno-r a');
  if (!liens.length) return;

  const fleche = tiroir.querySelector('.hdr-menu-l > li > a > svg');
  for (const lien of liens) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = lien.getAttribute('href') ?? '#';
    if (lien.hasAttribute('data-quiz-ouvrir')) {
      a.setAttribute('data-quiz-ouvrir', '');
      a.setAttribute('aria-haspopup', 'dialog');
    }
    const texte = document.createElement('span');
    texte.textContent = lien.textContent.trim();
    a.append(texte);
    if (fleche) a.append(fleche.cloneNode(true));
    li.append(a);
    ancre.before(li);
  }
}

/* Un ouvreur de quiz cliqué dans le tiroir : on ferme le tiroir avant. */
document.addEventListener('click', (event) => {
  const ouvreur = event.target.closest('dialog.hdr-menu [data-quiz-ouvrir]');
  if (ouvreur) ouvreur.closest('dialog')?.close();
});
